/**
 * Copilot is designed on a 1920x1080 surface. A smaller window shows that
 * surface scaled down as a whole, so nothing reflows and nothing scrolls.
 */
export const CANVAS_WIDTH = 1920;
export const CANVAS_HEIGHT = 1080;

/**
 * The zoom that fits the canvas in the window, and the size to lay out at
 * under that zoom. The layout fills the window, so a window that is not 16:9
 * gets a wider or taller canvas rather than empty bars. Never scales up.
 */
export const fitCanvas = (windowWidth, windowHeight) => {
  const zoom = Math.min(1, windowWidth / CANVAS_WIDTH, windowHeight / CANVAS_HEIGHT);
  return {
    zoom,
    width: Math.round(windowWidth / zoom),
    height: Math.round(windowHeight / zoom),
  };
};

/*
 * Under that zoom, panels are positioned in canvas pixels while the pointer,
 * the window size and measured boxes are in screen pixels. These convert.
 */

/** The page zoom fitCanvas applied, or 1. */
export const pageZoom = () => Number(document.documentElement.style.zoom) || 1;

/** A screen distance as canvas pixels. */
export const toCanvas = (value, zoom = pageZoom()) => value / zoom;

/** The window size in canvas pixels. */
export const canvasViewport = (zoom = pageZoom()) => ({
  width: toCanvas(window.innerWidth, zoom),
  height: toCanvas(window.innerHeight, zoom),
});

/** A getBoundingClientRect box in canvas pixels. */
export const canvasRect = (rect, zoom = pageZoom()) =>
  rect && {
    left: toCanvas(rect.left, zoom),
    top: toCanvas(rect.top, zoom),
    width: toCanvas(rect.width, zoom),
    height: toCanvas(rect.height, zoom),
  };
